<template>
  <v-dialog
      v-model="value"
      persistent
      width="340"
  >
    <v-card class="nv-dialog nv-process">
      <v-progress-circular
          indeterminate
          color="secondary"
          size="44"
          width="4"
      ></v-progress-circular>
      <div class="nv-process__text">
        <strong><slot name="content"></slot></strong>
        <span>Lütfen Bekleyiniz.</span>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ProcessLoading",
  props:['value']
}
</script>

<style scoped>

</style>